import React, { forwardRef } from 'react';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';

const InputSubmit = forwardRef((props, ref) => {
    const {
        value = 'Salvar',
        className,
        error,
        variant = 'primary',
        size = 'medium',
        fullWidth = false,
        disabled = false,
        ...restProps
    } = props;

    const buttonType = {
        primary: 'btn-primary',
        secondary: 'btn-primary',
        plus: 'bt-mais',
    };

    const buttonSize = {
        small: 'small',
        medium: 'medium',
        large: 'large',
    };

    return (
        <Button variant={variant} type={'submit'} className={classNames( 'btn',
            buttonSize[size],
            buttonType[variant],
            { 'cursor-not-allowed': disabled },
            className
        )}
            {...restProps}>
            { variant === 'plus' ? <img className='me-3' src={process.env.PUBLIC_URL + '/static/imagens/bt-mais.png'} alt='Adicionar' /> : ''}
            <span>{value}</span>
        </Button>
    );
});

InputSubmit.displayName = 'InputSubmit';

export default InputSubmit;
